<app-spinner></app-spinner>

@if(!isClientPortalRoute) {
<mat-toolbar>
  <mat-toolbar-row class="matToolbarRow">

    <table width="100%">
      <tr>
        <td class="miExactLogoCell">
          <img src="../assets/images/miexact-logo_inverse_white2.png" class="miExactLogo" /><span class="apptitle">Charity Central</span><span class="applegend">A MiExact Product</span>
        </td>
      </tr>
    </table>

    <!--<span><img src="../assets/images/miexact-logo_inverse_white.png" class="miExactLogo"  /> </span><span class="apptitle">Mortality Central</span><span class="applegend">A MiExact Product</span>-->
  </mat-toolbar-row>

  @if(hasLoggedInUser)
  {
  <mat-toolbar-row class="matToolbarRow">
    <div class="flexMenu" [hidden]="!hasLoggedInUser">
      <button mat-flat-button class="flexMenuButton" extended (click)="navigateToScreen('Home')">Home</button>
      <!-- <button mat-flat-button class="flexMenuButton" extended (click)="navigateToScreen('Reading')">Reading</button> -->
      <!-- <button mat-flat-button class="flexMenuButton" extended (click)="navigateToScreen('Reporting')">Reporting</button> -->
      <button mat-flat-button class="flexMenuButton" extended (click)="navigateToScreen('ProbateList')">Probate List</button>
      @if(isSupervisor() || isSystemAdministrator()) {
        <button mat-flat-button class="flexMenuButton" extended (click)="navigateToScreen('Reports')">Reports</button>
      }
      <!-- <button mat-flat-button class="flexMenuButton" extended (click)="navigateToScreen('CharityDatabase')">Charity Database</button> -->
      <!-- <button mat-flat-button class="flexMenuButton" extended (click)="navigateToScreen('PAFMatching')">PAF Matching</button> -->

@if(isSystemAdministrator()) {
        <div class="admin-dropdown-wrapper">
          <div class="admin-dropdown-backdrop" *ngIf="isAdminMenuOpen" (click)="isAdminMenuOpen = false"></div>
          <button mat-flat-button class="flexMenuButton" extended (click)="isAdminMenuOpen = !isAdminMenuOpen">Admin</button>
          <div class="admin-dropdown-menu" *ngIf="isAdminMenuOpen">
            <button class="admin-dropdown-item" (click)="navigateToScreen('AdminUsers'); isAdminMenuOpen = false">Users</button>
            <button class="admin-dropdown-item" (click)="navigateToScreen('AdminClients'); isAdminMenuOpen = false">Clients</button>
            <button class="admin-dropdown-item" (click)="navigateToScreen('AdminBeneficiaries'); isAdminMenuOpen = false">Beneficiaries</button>
            <button class="admin-dropdown-item" (click)="navigateToScreen('AdminUtilities'); isAdminMenuOpen = false">Utilities</button>
          </div>
        </div>
      }

      <div class="user-profile-container">
        <button mat-icon-button class="user-profile-button" [matMenuTriggerFor]="userMenu">
          <span class="user-avatar">{{getUserInitials()}}</span>
        </button>
        <mat-menu #userMenu="matMenu">
          <div class="user-menu-header">
            <span class="user-menu-name">{{loggedInUser?.firstName}} {{loggedInUser?.lastName}}</span>
            <span class="user-menu-email">{{loggedInUser?.email}}</span>
          </div>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>Logout</span>
          </button>
        </mat-menu>
      </div>
    </div>

  </mat-toolbar-row>
  }
  @else if(!hasLoggedInUser)
  {
  <mat-toolbar-row class="matToolbarRow">
    <div class="flexMenu" [hidden]="hasLoggedInUser">
      <button mat-flat-button color="primary" class="flexMenuButton" extended>Nobody logged in</button>
    </div>
  </mat-toolbar-row>
  }

</mat-toolbar>

@if(!hasLoggedInUser){
<app-login (loggedInUser)="userLoggedInOrOutStatusChange($event)"></app-login>
}
}

@if(isClientPortalRoute || hasLoggedInUser){
<router-outlet></router-outlet>
}
